<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="batchName"
                    label="批次名称"
                >
                    <el-input
                        v-model="queryFormModel.batchName"
                        placeholder="请输入批次名称"
                    />
                </el-form-item>
                <el-form-item
                    prop="batchSn"
                    label="批次编号"
                >
                    <el-input
                        v-model="queryFormModel.batchSn"
                        placeholder="请输入批次编号"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset1"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        size="small"
                        @click="onAdd"
                    >
                        新增
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column
                    prop="batchName"
                    label="批次名称"
                    min-width="100"
                />
                <el-table-column
                    prop="batchSn"
                    label="批次编号"
                    min-width="100"
                />
                <el-table-column
                    prop="codeSnPrefix"
                    label="防伪码前缀"
                    width="85"
                />
                <el-table-column
                    prop="codeSnBegin"
                    label="防伪码起始"
                    width="85"
                />
                <el-table-column
                    prop="applyNum"
                    label="申请数量"
                    min-width="100"
                />
                <el-table-column
                    prop="activatedNum"
                    label="激活数量"
                    min-width="100"
                />
                <el-table-column
                    prop="marketCodeStatusName"
                    label="申请状态"
                    width="70"
                />
                <el-table-column
                    prop="remarks"
                    label="备注"
                    min-width="100"
                />
                <el-table-column
                    label="创建时间"
                    width="135"
                >
                    <template slot-scope="scope">
                        {{ scope.row.insertTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="isAvailable"
                    label="是否可用"
                    width="70"
                >
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.isAvailable"
                            @input="onIsAvailableInput($event,scope)"
                        />
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="130"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="exportExcel(scope.row)"
                            v-if="scope.row.marketCodeStatus === 100"
                        >
                            导出二维码
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableDelete(scope.row.id)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>

        <!-- 弹框 -->
        <!-- 新增/编辑 -->
        <el-dialog
            :title="addDialog.formModel.id ? '编辑' : '新增'"
            center
            width="600px"
            :visible.sync="addDialog.isVisible"
            @closed="onAddDialogCancel"
        >
            <el-form
                ref="addForm"
                size="small"
                :model="addDialog.formModel"
                :rules="addDialog.formRules"
            >
                <el-form-item
                    prop="batchName"
                    label="批次名称"
                    label-width="8em"
                >
                    <el-input
                        v-model="addDialog.formModel.batchName"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="batchSn"
                    label="批次编号"
                    label-width="8em"
                >
                    <el-input
                        v-model="addDialog.formModel.batchSn"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="codeSnPrefix"
                    label="防伪码前缀"
                    label-width="8em"
                >
                    <el-input
                        v-model="addDialog.formModel.codeSnPrefix"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="codeSnBegin"
                    label="防伪码起始"
                    label-width="8em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="0"
                        v-model.number="addDialog.formModel.codeSnBegin"
                    />
                </el-form-item>
                <el-form-item
                    prop="applyNum"
                    label="申请数量"
                    label-width="8em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="1"
                        :max="20000000"
                        :precision="0"
                        v-model.number="addDialog.formModel.applyNum"
                    />
                </el-form-item>
                <el-form-item
                    prop="remarks"
                    label="备注"
                    label-width="8em"
                >
                    <el-input
                        type="textarea"
                        v-model="addDialog.formModel.remarks"
                        auto-complete="off"
                    />
                </el-form-item>
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onAddDialogConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onAddDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'Variable',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                batchName: '', // 批次名称
                batchSn: '', // 批次编号
            },
            // 新增/编辑
            addDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    batchName: '',
                    batchSn: '',
                    applyNum: 1,
                    remarks: '',
                    codeSnPrefix: '',
                    codeSnBegin: '',
                },
                // 表单校验规则
                formRules: {
                    batchName: {
                        required: true,
                        message: '请输入批次名称',
                        trigger: 'blur',
                    },
                    batchSn: {
                        required: true,
                        message: '请输入批次编号',
                        trigger: 'blur',
                    },
                    applyNum: {
                        required: true,
                        message: '请输入申请数量',
                        trigger: 'blur',
                    },
                    codeSnBegin: {
                        required: true,
                        message: '请输入',
                        trigger: 'blur',
                    },
                    codeSnPrefix: {
                        required: true,
                        message: '请输入',
                        trigger: 'blur',
                    },
                },
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Ts.MarketCodeBatch.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onAdd() {
            this.addDialog.isVisible = true;
            this.$nextTick(() => {
                const { addForm } = this.$refs;
                addForm.resetFields();
                const { formModel } = this.addDialog;
                formModel.id = '';
            });
        },
        onAddDialogConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Ts.MarketCodeBatch.createMarketCode({
                    ...this.addDialog.formModel,
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                    this.addDialog.isVisible = false;
                });
            });
        },
        onAddDialogCancel() {
            const { addForm } = this.$refs;
            addForm.resetFields();
            const { formModel } = this.addDialog;
            formModel.id = '';
            this.addDialog.isVisible = false;
        },
        onIsAvailableInput(val, scope) {
            const { row } = scope;
            if (!row) return;
            this.$api.Ts.MarketCodeBatch.status({
                id: row.id,
                isAvailable: row.isAvailable,
            })
                .then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                })
                .catch(() => {
                    this.$message({
                        message: '操作失败请重试！',
                        type: 'error',
                    });
                    row.isAvailable = !row.isAvailable;
                });
        },
        // excel导出
        exportExcel(row) {
            this.$http.href('/ts/marketCodeBatch/exportExcel', {
                marketCodeBatchId: row.id,
            });
        },

        onTableDelete(ids) {
            this.$confirm('是否确定要删除！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.loading = this.$loading({
                    lock: true,
                    text: '删除中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                this.$api.Ts.MarketCodeBatch.delete({ ids }).then(json => {
                    this.loading.close();
                    const res = json.data;
                    if (res.success) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        });
                        this.onQuery(this.pagination);
                    } else {
                        this.$alert(res.msg, '温馨提示', {
                            type: 'error',
                            // callback(action) {},
                        });
                    }
                });
            });
        },
    },
    created() {
        this.initCatList();
    },
};
</script>

<style lang="scss">
</style>
